/* TheVault Theme - Global JS */

document.addEventListener('DOMContentLoaded', function () {

  // ── Mobile nav ──────────────────────────────────────────────────────────────
  const menuToggle = document.querySelector('.header__menu-toggle');
  const mobileNav  = document.querySelector('.mobile-nav');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      const isOpen = mobileNav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
  }
  const mobileNavOverlay = document.querySelector('.mobile-nav__overlay');
  if (mobileNavOverlay) {
    mobileNavOverlay.addEventListener('click', function () {
      mobileNav.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  // ── Countdown timer ─────────────────────────────────────────────────────────
  const countdownEl = document.getElementById('ogk-countdown');
  if (countdownEl) {
    const end = new Date();
    end.setHours(23, 59, 59, 0);
    function tick() {
      const now = new Date(), diff = Math.max(0, end - now);
      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      countdownEl.textContent =
        ('0' + h).slice(-2) + 'H : ' + ('0' + m).slice(-2) + 'M : ' + ('0' + s).slice(-2) + 'S';
      if (diff > 0) setTimeout(tick, 1000);
    }
    tick();
  }

  // ── Announcement bar ticker ──────────────────────────────────────────────────
  const ticker = document.querySelector('.announcement__ticker');
  if (ticker) {
    const items = ticker.querySelectorAll('.announcement__item');
    if (items.length > 1) {
      let idx = 0;
      setInterval(function () {
        items[idx].classList.remove('is-active');
        idx = (idx + 1) % items.length;
        items[idx].classList.add('is-active');
      }, 3000);
    }
  }

  // ── Sticky header ───────────────────────────────────────────────────────────
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    });
  }

  // ── Variant selector (product page) ─────────────────────────────────────────
  document.querySelectorAll('.variant-selector').forEach(function (sel) {
    sel.addEventListener('change', function () {
      const selected = this.options[this.selectedIndex];
      const price = selected.dataset.price;
      const comparePrice = selected.dataset.comparePrice;
      const priceEl = document.querySelector('.product-price__current');
      const compareEl = document.querySelector('.product-price__compare');
      if (priceEl && price) priceEl.textContent = price;
      if (compareEl) compareEl.textContent = comparePrice || '';
    });
  });

  // ── Mini cart ────────────────────────────────────────────────────────────────
  window.openMiniCart = function () {
    renderMiniCart();
    document.getElementById('mini-cart').classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };
  window.closeMiniCart = function () {
    document.getElementById('mini-cart').classList.remove('is-open');
    document.body.style.overflow = '';
  };

  function moneyFormat(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  function renderMiniCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartBadge(cart.item_count);
        const itemsEl  = document.getElementById('mini-cart-items');
        const footEl   = document.getElementById('mini-cart-foot');
        const countEl  = document.getElementById('mini-cart-count');
        const subEl    = document.getElementById('mini-cart-subtotal');

        if (countEl) countEl.textContent = cart.item_count;
        if (subEl)   subEl.textContent   = moneyFormat(cart.total_price);

        if (!cart.item_count) {
          itemsEl.innerHTML = '<p class="mini-cart__empty">Your bag is empty</p>';
          if (footEl) footEl.style.display = 'none';
          return;
        }

        if (footEl) footEl.style.display = '';

        itemsEl.innerHTML = cart.items.map(function (item) {
          const img = item.featured_image
            ? item.featured_image.url
            : 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEAAAAALAAAAAABAAEAAAI=';
          return [
            '<div class="mini-cart__item" data-key="' + item.key + '">',
              '<img class="mini-cart__item-img" src="' + img + '" alt="' + item.title.replace(/"/g, '&quot;') + '">',
              '<div>',
                '<p class="mini-cart__item-title">' + item.product_title + '</p>',
                item.variant_title && item.variant_title !== 'Default Title'
                  ? '<p class="mini-cart__item-variant">' + item.variant_title + '</p>'
                  : '',
                '<p class="mini-cart__item-price">' + moneyFormat(item.final_line_price) + '</p>',
                '<div class="mini-cart__qty">',
                  '<button onclick="window.updateCartItem(\'' + item.key + '\',' + (item.quantity - 1) + ')">−</button>',
                  '<span>' + item.quantity + '</span>',
                  '<button onclick="window.updateCartItem(\'' + item.key + '\',' + (item.quantity + 1) + ')">+</button>',
                '</div>',
              '</div>',
              '<button class="mini-cart__item-remove" onclick="window.updateCartItem(\'' + item.key + '\',0)" aria-label="Remove">×</button>',
            '</div>'
          ].join('');
        }).join('');
      });
  }

  window.updateCartItem = function (key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      updateCartBadge(cart.item_count);
      renderMiniCart();
    });
  };

  function updateCartBadge(count) {
    const badges = document.querySelectorAll('#cart-count-badge, .header__cart-count');
    badges.forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  // ── Add to cart (AJAX) ───────────────────────────────────────────────────────
  window.showAtcPopup = function(item) {
    const popup    = document.getElementById('atc-popup');
    const imgEl    = document.getElementById('atc-popup-img');
    const titleEl  = document.getElementById('atc-popup-title');
    const varEl    = document.getElementById('atc-popup-variant');
    if (!popup) return;

    if (imgEl && item.image) imgEl.src = item.image;
    if (titleEl) titleEl.textContent = item.product_title || item.title;
    if (varEl) varEl.textContent =
      (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';

    popup.classList.add('is-visible');
    clearTimeout(popup._timer);
    popup._timer = setTimeout(function () {
      popup.classList.remove('is-visible');
    }, 4000);
  }

  function addToCart(formData, btn) {
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart error ' + r.status);
        return r.json();
      })
      .then(function (item) {
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          updateCartBadge(cart.item_count);
          showAtcPopup(item);
          if (btn) { btn.disabled = false; btn.textContent = 'Add to Bag'; }
        });
      })
      .catch(function (err) {
        console.error(err);
        if (btn) { btn.disabled = false; btn.textContent = 'Add to Bag'; }
        alert('Could not add to cart. Please try again.');
      });
  }

  document.querySelectorAll('.add-to-cart-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = form.querySelector('[type=submit]');
      addToCart(new FormData(form), btn);
    });
  });

  // ── Buy Now button ───────────────────────────────────────────────────────────
  const buyNowBtn = document.getElementById('buy-now-btn');
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', function () {
      const form = document.querySelector('.add-to-cart-form');
      if (!form) return;
      buyNowBtn.disabled = true;
      buyNowBtn.textContent = 'Redirecting…';
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) { return r.json(); })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function () {
          buyNowBtn.disabled = false;
          buyNowBtn.textContent = 'Buy Now — Checkout';
        });
    });
  }

});
